var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPwCFunctIconsImageOutlineBlackRgb2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104 99",
    style: {
      enableBackground: "new 0 0 104 99"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DB536A;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#E0301E;}\n\t.st3{fill:#D04A02;}\n\t.st4{fill:#464646;}\n\t.st5{fill:#7D7D7D;}\n\t.st6{fill:#2D2D2D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M83.5,22.5h-63c-2.5,0-4.5,2-4.5,4.5v45c0,1.7,1,3.1,2.3,3.9c0.7,0.4,1.4,0.6,2.2,0.6h63c0.8,0,1.6-0.3,2.2-0.7 C87.1,75,88,73.7,88,72V27C88,24.5,86,22.5,83.5,22.5z M27.2,72l11.3-14l3.2,4l3.5,4.3l3.5-4.3l10-12.4L76.9,72H27.2z M83.5,72 h-0.9L58.8,42.5L45.3,59.2l-6.8-8.3L21.4,72h-0.9V27h63V72z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,49.5c5,0,9-4,9-9c0-5-4-9-9-9s-9,4-9,9C25,45.5,29,49.5,34,49.5z M34,36c2.5,0,4.5,2,4.5,4.5c0,2.5-2,4.5-4.5,4.5 s-4.5-2-4.5-4.5C29.5,38,31.5,36,34,36z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwCFunctIconsImageOutlineBlackRgb2);
export default __webpack_public_path__ + "static/media/PwC_Funct_Icons_Image_Outline_Black_RGB 2.cd87c45884087f5481ede28d64d2cd56.svg";
export { ForwardRef as ReactComponent };